import { FC } from 'react'

import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { CTAButton } from 'src/Components/Buttons/CTAButton'
import { DangerButton } from 'src/Components/Buttons/DangerButton'
import { subscription } from 'src/Router/routes'

const StyledCTAButton = styled(CTAButton)`
  width: 200px;
  padding: 8px 16px;
`

const StyledDangerButton = styled(DangerButton)`
  width: 200px;
`

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (min-width: 567px) {
    flex-direction: row;
  }
`

interface CancelButtonsProps {
  onCancel: () => void
  disabled?: boolean
  loading?: boolean
}

export const CancelButtons: FC<CancelButtonsProps> = ({
  onCancel,
  disabled,
  loading,
}) => {
  const navigate = useNavigate()

  const handleClose = (): void => {
    navigate(subscription)
  }
  return (
    <ButtonsContainer>
      <StyledCTAButton type='button' onClick={handleClose}>
        Keep Subscription
      </StyledCTAButton>
      <StyledDangerButton
        type='button'
        loading={loading}
        disabled={disabled}
        onClick={onCancel}
      >
        Cancel Subscription
      </StyledDangerButton>
    </ButtonsContainer>
  )
}
